<template>
  <div>
    <cabecalho
      title="FINANCEIRO.ENDERECO"
      title_type="modal"
      :btnPrimary="true"
      btnPrimaryText="GERAL.ADICIONAR"
      @primary-method="abrirFecharForm"
    />

    <div v-if="formulario.exibir" class="row">
      <div class="col-12 col-md-4">
        <input-select-search
          ref="paisId"
          :label="$t(`FINANCEIRO.ENDERECO_PAIS`)"
          :options="opcoes.listaPais"
          v-model="formulario.dados.paisId"
          :isDisabled="true"
        />
      </div>
      <div class="col-12 col-md-4">
        <input-mask
          ref="cep"
          v-model="formulario.dados.cep"
          :label="$t('FINANCEIRO.CEP')"
          :mask="['#####-###']"
          placeholder="Digite apenas números"
          type="text"
        />
      </div>
      <div class="col-12 col-md-4">
        <input-select-search
          ref="estadoId"
          :label="$t(`FINANCEIRO.ENDERECO_ESTADO`)"
          placeholder="Digite ou selecione"
          :options="opcoes.listaEstado"
          v-model="formulario.dados.estadoId"
        />
      </div>
      <div class="col-12 col-md-4">
        <input-select-search
          ref="municipioId"
          :label="$t(`FINANCEIRO.ENDERECO_MUNICIPIO`)"
          placeholder="GERAL.DIGITE_OU_SELECIONE"
          :options="opcoes.listaMunicipio"
          v-model="formulario.dados.municipioId"
        />
      </div>
      <div class="col-12 col-md-4">
        <input-text
          ref="bairro"
          v-model="formulario.dados.bairro"
          :label="$t('FINANCEIRO.ENDERECO_BAIRRO')"
          :placeholder="$t('FINANCEIRO.ENDERECO_BAIRRO')"
        />
      </div>
      <div class="col-12 col-md-4">
        <input-text
          ref="logradouro"
          v-model="formulario.dados.logradouro"
          :label="$t('FINANCEIRO.ENDERECO_LOGRADOURO')"
          :placeholder="$t('FINANCEIRO.ENDERECO_LOGRADOURO')"
        />
      </div>
      <div class="col-12 col-md-2">
        <input-text
          ref="numero"
          v-model="formulario.dados.numero"
          :label="$t('FINANCEIRO.ENDERECO_NUMERO')"
          :placeholder="$t('FINANCEIRO.ENDERECO_NUMERO')"
        />
      </div>
      <div class="col-12 col-md-10">
        <input-text
          ref="complemento"
          v-model="formulario.dados.complemento"
          :label="$t('FINANCEIRO.ENDERECO_COMPLEMENTO')"
          :placeholder="$t('FINANCEIRO.ENDERECO_COMPLEMENTO')"
        />
      </div>
      <div class="col-12 mb-4">
        <b-button variant="primary" @click="adicionarEndereco">
          {{ $t('FINANCEIRO.ADICIONAR_ENDERECO') }}
        </b-button>
      </div>
    </div>

    <!-- Tabela -->
    <b-table
      :fields="fields"
      :items="enderecos"
      :empty-text="$t('GERAL.NENHUM_REGISTRO')"
      head-variant="light"
      stacked="md"
      responsive
      show-empty
      striped
      hover
    >
      <template #cell(acoes)="item">
        <b-dropdown variant="outline-default">
          <b-dropdown-item @click="excluirEndereco(item)">
            {{ $t('FINANCEIRO.EXCLUIR_ENDERECO') }}
          </b-dropdown-item>
        </b-dropdown>
      </template>
    </b-table>
  </div>
</template>
<script>
// Components:
import { START_LOADING, STOP_LOADING } from '@/store/Store';
import { Cabecalho } from '@/components/headers';
import EnderecoService from '@/common/services/endereco/endereco.service';
import { InputMask, InputText, InputSelectSearch } from '@/components/inputs';
import helpers from '@/common/utils/helpers';

import mensagem from '@/common/utils/mensagem';

export default {
  props: {
    enderecos: { type: Array, default: Array },
  },
  components: {
    Cabecalho,
    InputMask,
    InputText,
    InputSelectSearch,
  },
  watch: {
    'formulario.exibir': 'verificaNovoOuEditar',
    'formulario.dados.cep': 'buscaDadosCEP',
    'formulario.dados.estadoId': 'getMunicipios',
  },
  mounted() {
    this.enderecosCopia = this.enderecos;
    this.getPaises();
  },
  data() {
    return {
      enderecosCopia: [],
      enderecoEditar: {},
      dadosPesquisaCEP: [],
      formulario: {
        exibir: false,
        dados: {},
      },
      fields: [
        {
          key: 'cep',
          label: this.$t('FINANCEIRO.CEP'),
          sortable: true,
        },
        {
          key: 'bairro',
          label: this.$t('FINANCEIRO.ENDERECO_BAIRRO'),
          sortable: true,
        },
        {
          key: 'logradouro',
          label: this.$t('FINANCEIRO.ENDERECO_LOGRADOURO'),
          sortable: true,
        },
        {
          key: 'numero',
          label: this.$t('FINANCEIRO.ENDERECO_NUMERO'),
          sortable: true,
        },
        {
          key: 'complemento',
          label: this.$t('FINANCEIRO.ENDERECO_COMPLEMENTO'),
          sortable: true,
        },
        {
          key: 'acoes',
          label: 'Ações',
        },
      ],
      opcoes: {
        brasil: [],
        listaPais: [],
        listaEstado: [],
        listaMunicipio: [],
        listaTipoEndereco: [],
      },
    };
  },
  methods: {
    async excluirEndereco(item) {
      const respostaExclusao = await mensagem.confirmacao(
        null,
        this.$t('FINANCEIRO.CONFIRMAR_EXCLUIR_ENDERECO')
      );
      if (respostaExclusao.isConfirmed) {
        this.$emit('excluir', item);
      }
    },
    // FUNÇÕES AUXILIARES:
    abrirFecharForm() {
      this.formulario.exibir == false
        ? (this.formulario.exibir = true)
        : (this.formulario.exibir = false);
    },

    getPaises() {
      this.$store.dispatch(START_LOADING);
      EnderecoService.buscarNacionalidades()
        .then(({ data }) => {
          data = data.map((row) => ({
            ...row,
            value: row.id,
            text: row.nome,
          }));
          this.opcoes.listaPais = data;

          this.getBrasil();
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },

    getBrasil() {
      this.opcoes.listaPais.forEach((element) => {
        if (element.nome == 'Brasil') {
          this.formulario.dados.paisId = element.id;
          return (this.opcoes.brasil = element);
        }
      });
    },

    getEstados() {
      this.$store.dispatch(START_LOADING);
      EnderecoService.buscarEstados(this.opcoes.brasil.id)
        .then(({ data }) => {
          data = data.map((row) => ({
            ...row,
            value: row.id,
            text: row.nome,
          }));
          this.opcoes.listaEstado = data;
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },

    getMunicipios() {
      this.$store.dispatch(START_LOADING);
      if (this.formulario.dados.estadoId)
        EnderecoService.buscarMunicipios(this.formulario.dados.estadoId)
          .then(({ data }) => {
            data = data.map((row) => ({
              ...row,
              value: row.id,
              text: row.nome,
            }));
            this.opcoes.listaMunicipio = data;
            if (this.dadosPesquisaCEP) {
              this.encontrarMunicipio();
            }
          })
          .catch((err) => {
            mensagem.showErrors(err);
          })
          .finally(() => {
            this.$store.dispatch(STOP_LOADING);
          });
    },

    encontrarMunicipio() {
      this.opcoes.listaMunicipio.forEach((element) => {
        if (element.nome == this.dadosPesquisaCEP.localidade) {
          this.formulario.dados.municipioId = element.id;
        }
      });
    },

    verificaNovoOuEditar() {
      this.formulario.id
        ? (this.formulario.dados = this.enderecoEditar)
        : (this.formulario.dados = {});
      this.getPaises();
      this.getEstados();
      this.getMunicipios();
    },

    async buscaDadosCEP() {
      if (this.formulario.dados.cep.length != 9) return;
      this.$store.dispatch(START_LOADING);

      await EnderecoService.buscarInformacoesCep(this.formulario.dados.cep)
        .then((endereco) => {
          this.formulario.dados = { 
            ...this.formulario.dados,
            ...endereco,
            logradouro: endereco.logradouro || this.formulario.dados.logradouro,
            bairro: endereco.bairro || this.formulario.dados.bairro,            
          };
        })
        .catch((error) => {
          mensagem.warning(this.$t('CAMPOS_VALIDACAO.CEP_INEXISTENTE'), error);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },

    adicionarEndereco() {
      if (!this.validarFormulario()) return;
      this.formulario.dados.cep = this.formulario?.dados?.cep
        .replace('-', '')
        .replace('.', '');

      this.enderecos.push(this.formulario.dados);
      this.formulario.dados = {};
      this.$emit('atualiza-form', this.enderecos);
      this.formulario.exibir = false;
    },

    validarFormulario() {
      return helpers.validarFormulario(this.$refs);
    },
  },
};
</script>
